/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TasksMoveModal from 'DesignSystem/TasksMoveModal/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/MoveModal/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let selectedBulkTasksValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'bulk_tasks',
})
  return (<React.Fragment
>
<TasksMoveModal
  viewPath={`${viewPath}/TasksMoveModal`}
 data="selected.bulk_tasks"
 tasks={selectedBulkTasksValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}